import $ from "jquery";
// Generated by CoffeeScript 1.12.2
let Logout;

Logout = (() => {
    function Logout() {
        $(document).on("click", "#logout-button", e => {
            e.preventDefault();
            return $("#logout-form").trigger("submit");
        });
    }

    return Logout;
})();

export default new Logout();
